import { addNewBlock } from '../utils/add-new-block';
import { convert } from '../utils/convert';
import { AnalogInput, AnalogTemperatureSensor, RadioSensor, RadioSensorValue, WiredTemperatureSensor, } from 'z3k-config';
import { FixedBlockType } from '../types/block-type';
import { radioSensorValueTranslate } from '../utils/translates';
function addAnalogInputSensorReadingBlock(color_of_sensor_reading_blocks, config) {
    const options = convert(AnalogInput.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block = {
        message0: 'Величина входа %1',
        args0: [
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
        ],
        inputsInline: false,
        output: 'Number',
        tooltip: '',
        helpUrl: '',
        colour: color_of_sensor_reading_blocks,
    };
    const block_type = FixedBlockType.analog_input;
    addNewBlock(block_type, block);
    return block_type;
}
function addRadioSensorReadingBlock(color_of_sensor_reading_blocks, config) {
    const options = convert(RadioSensor.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const reading_options = [
        [
            radioSensorValueTranslate[RadioSensorValue.TEMPERATURE],
            RadioSensorValue.TEMPERATURE.toString(),
        ],
        [
            radioSensorValueTranslate[RadioSensorValue.HUMIDITY],
            RadioSensorValue.HUMIDITY.toString(),
        ],
        [
            radioSensorValueTranslate[RadioSensorValue.BATTERY_LEVEL],
            RadioSensorValue.BATTERY_LEVEL.toString(),
        ],
        [
            radioSensorValueTranslate[RadioSensorValue.RSSI],
            RadioSensorValue.RSSI.toString(),
        ],
    ];
    const block = {
        message0: 'Значение %3 %2 радиодатчика %1',
        args0: [
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
            { type: 'input_dummy' },
            {
                type: 'field_dropdown',
                name: 'value_type',
                options: reading_options,
            },
        ],
        inputsInline: false,
        output: 'Number',
        tooltip: '',
        helpUrl: '',
        colour: color_of_sensor_reading_blocks,
    };
    const block_type = FixedBlockType.radio_input;
    addNewBlock(block_type, block);
    return block_type;
}
function addTemperatureSensorReadingBlock(color_of_sensor_reading_blocks, config) {
    const sensors = [
        ...WiredTemperatureSensor.get.all(config),
        ...AnalogTemperatureSensor.get.all(config),
        //FIXME: когда реализуют в прошивке, можно вернуть
        // ...BoilerAdapter.get.all(config),
    ];
    const options = convert(sensors);
    if (options.length === 0) {
        return null;
    }
    const block = {
        message0: 'Температура %1',
        args0: [
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
        ],
        inputsInline: false,
        output: 'Number',
        tooltip: '',
        helpUrl: '',
        colour: color_of_sensor_reading_blocks,
    };
    const block_type = FixedBlockType.temperature_input;
    addNewBlock(block_type, block);
    return block_type;
}
export function generateSensorReadingsBlock(color_of_logic_blocks, config) {
    return [
        addAnalogInputSensorReadingBlock,
        addTemperatureSensorReadingBlock,
        addRadioSensorReadingBlock,
    ]
        .map((func) => func(color_of_logic_blocks, config))
        .filter((item) => item != null);
}
